module.exports = __webpack_public_path__ + "img/advantage1.e60496ac.svg";